import React, { useMemo , useEffect, useState} from 'react';


import PrintButton from '../../components/buttons/PrintButton';
import AppConfigurationTitle from '../../components/header/AppConfigurationTitle';
import RadarChartReport from "../../components/questionnaireReport/RadarChartReport"
import HorizontalBarChartReport from "../../components/questionnaireReport/HorizontalBarChartReport";
import ScatterChartReport from "../../components/questionnaireReport/ScatterChartReport";
import WrittenAnalysisReport from '../../components/questionnaireReport/WrittenAnalysisReport';
import ResponseReport from '../../components/questionnaireReport/ResponsesReport';
import LocalStorageDataStorer from '../../../dataAccessLayer/localStorage/LocalStorageDataStorer';
import LocalStorageKey from '../../../dataAccessLayer/localStorage/LocalStorageKey';
import AccessControlInspector from '../../../serviceLayer/authorization/AccessControlInspector';

export default function QuestionnaireReport(props){

    const CHARACTERTYPE_DATA = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.allCharacterTypesDataPoints);
    const SCATTERCHART_DATA = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.allScatterChartDataPoints);
    const MOST_TWO_DOMINANT_CHARACTER_TYPES = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.mostTwoDominantCharacterTypes);

    const[canDisplayPage, setCanDisplayPage] = useState(false);
    const[canExportToPdf, setCanExportToPdf] = useState(false);

    useEffect(()=>{
        processUserPermissions(props.resource.name, props.resource.actions);
    },[]);

    function processUserPermissions(resourceName , actions){
        const userCanDisplayPage = AccessControlInspector.userHasPermission(resourceName, actions._display_page);
        const userCanExportToPdf = AccessControlInspector.userHasPermission(resourceName, actions._export_to_pdf);
        setCanDisplayPage(userCanDisplayPage);
        setCanExportToPdf(userCanExportToPdf);
    }

    //console.log("QuestionnaireReport, MOST_TWO_DOMINANT_CHARACTER_TYPES" , MOST_TWO_DOMINANT_CHARACTER_TYPES);
    return (<div className="page-container app-container container-flex-column">
        <AppConfigurationTitle path="/private/main" title="" /> 
        {canDisplayPage && <>
           {canExportToPdf && <PrintButton /> }
            <header className="report-header">
                <h1>Questionnaire Results</h1>
                <p className="subtitle">Detailed breakdown of character types and individual question mapping</p>
            </header>
            <div className="dashboard-grid">
                <RadarChartReport data={CHARACTERTYPE_DATA}/>
                <HorizontalBarChartReport data={CHARACTERTYPE_DATA} />
                {/*<div className="min-h-screen bg-slate-100 p-2 md:p-8 font-sans">
                    <style>{`
                            .chart-scroll-container {
                            width: 100%;
                            overflow-x: auto;
                            overflow-y: hidden;
                            -webkit-overflow-scrolling: touch;
                            }
                            .chart-view-wrapper {
                            width: 100%;
                            background: #fff;
                            }
                            / Style scrollbar for better visibility on desktop mobile view /
                            .chart-scroll-container::-webkit-scrollbar {
                            height: 4px;
                            }
                            .chart-scroll-container::-webkit-scrollbar-track {
                            background: #f1f5f9;
                            }
                            .chart-scroll-container::-webkit-scrollbar-thumb {
                            background: #cbd5e1;
                            border-radius: 10px;
                            }
                    `}</style>      
                    <div className="max-w-4xl mx-auto">
                        <ScatterChartReport  characterTypes={CHARACTERTYPE_DATA} questionsData={SCATTERCHART_DATA} />
                    </div>
                </div>*/}
                <>
                    <WrittenAnalysisReport data={MOST_TWO_DOMINANT_CHARACTER_TYPES} />
                </>
                    <ResponseReport />
                <>
                </>
            </div>    
        </>}   
    </div>)
}